// extracted by mini-css-extract-plugin
module.exports = {"cityItemBlock":"QHRdQL-X2jtPGbqNHtkfX","cityItem":"dNnih61ZWuvrGASZeFlGJ"};